<template>
  <div class="animate_animated animate__slideInRight">
 
    <div class="fixed w-full z-10 left-0 top-0">
      <div class="absolute w-full top-0 left-0 z-10 bg-fix">
        <div class="flex px-4 py-6 items-center ">
          <div class="w-1/2">
            <a @click="$router.go(-1)"><img src="@/assets/back-arrow-white.svg" alt=""></a>
          </div>
          <div class="w-1/2 flex justify-end">
            <span class="flex bg-white items-center rounded px-2 py-1 pointer-events-none">
              <span class="text-content text-xxs font-medium ">{{ projectDetails.possession_status }}</span>
            </span>
          </div>
        </div>
      </div>
      <img :src="photoUrl.length > 0 ? photoUrl : 'https://engage-prod.s3.ap-south-1.amazonaws.com/images/app/engage-app-prod.jpeg'" alt="" class="w-full h-48 object-cover object-center">
    </div>
    <div class="mt-48 relative z-50">
      <div class="bg-gray-50 min-h-screen pb-12">
        <div class="flex items-center p-2">
          <div class="w-full">
            <div class="p-3">
            
              <div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4">
                <div class="flex items-center mb-1">
                  <span v-if="created_user" class="text-xs text-slate-500 font-medium mr-2">{{ projectDetails.user_name }}</span>
                  <h2 class="text-content text-base font-medium">{{ projectDetails.name }}</h2>
                </div>
                <div class="space-y-2">
                  <span class="block text-sm text-content mb-2">{{ projectDetails.location }}</span>
                  <span class="block text-sm text-gray-500"font-medium>{{ projectDetails.locality }}, {{ projectDetails.city }}</span>
                  <span class="block text-xs text-slate-500 mb-2 mb-2" v-if="projectDetails.rera_no">RERA No: <span
                      class="font-semibold bg-gray-100 rounded-full py-1 px-2">{{ projectDetails.rera_no }}</span></span>
                  <div class="">
                    <span class="block text-xs text-slate-500 mb-2 mb-2">Comment:</span>
                    <span class="block text-sm text-slate-800">{{ projectDetails.description }}</span>
                  </div>
                </div>
              </div>
               <div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4" v-if="photoUrl.length > 0">
                 <div class="">
                  <span class="text-sm text-content text-opacity-50 block mb-2">Photos</span>
                  <ImageViewer :visible="visible" :imgs="photoUrl" @hide="handleHide" />
                  <div class="flex justify-between">
                    <div v-for="(img_url, index) in photoUrl" :key="index" :class="index > 3 ? 'hidden' : ''"
                      class="mr-2 img-gallery w-full" @click="() => showImg(img_url)">
                      <span
                        class="text-sm absolute  items-center justify-center w-full h-full text-white z-10 font-medium hidden">{{ index
                            + 1
                        }}+</span>
                      <img :src="img_url" alt="" class="w-full max-w-full rounded-sm h-20 object-cover h-fix">
                    </div>
                  </div>
                </div>
               </div>
                 <div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4" v-if="projectDetails.developer_name">
                  <div class="mb-2">
                    <span class="block text-xs text-slate-500 mb-2 ">Developer Name:</span>
                    <span class="block text-sm text-slate-800">{{ projectDetails.developer_name }}</span>
                  </div>
                   <div class="">
                    <span class="block text-xs text-slate-500 mb-2 ">Developer Contact:</span>
                    <span class="block text-sm text-slate-800">{{ projectDetails.developer_contact }}</span>
                  </div>
                  
                 </div>

                  <div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4" v-if="projectDetails.formatted_possession_date">
                  <div class="mb-2">
                    <span class="block text-xs text-slate-500 mb-2 ">Possession Date:</span>
                    <span class="block text-sm text-slate-800">{{ projectDetails.formatted_possession_date }}</span>
                  </div>
                   <div class="">
                    <span class="block text-xs text-slate-500 mb-2 ">Project Approved by:</span>
                    <span class="block text-sm text-slate-800">{{ projectDetails.project_approve_by }}</span>
                  </div>
                  
                 </div>

                  <div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4">
                  <div class="" v-if="projectDetails.property_age">
                    <span class="block text-xs text-slate-500 mb-2 ">Property Age:</span>
                    <span class="block text-sm text-slate-800">{{ projectDetails.property_age }}</span>
                  </div>
                   <div class="mt-2" v-if="projectDetails.amenity_ids && projectDetails.amenity_ids.length">  
                    <span class="block text-xs text-slate-500 mb-2 mb-1">Property Amenities:</span>
                    <span class="inline-block px-3 py-1 mr-2 mb-2 rounded-full bg-slate-50 border border-slate-200 text-content text-xs font-normal"
                  v-for="(am, key) in projectDetails.amenity_ids" :key="key">{{ am.name }}</span>
                  </div>
                  
                 </div>
              <div class=" mb-4">
                <a class="shadow-sm ring-1 ring-black/5 flex items-center justify-center gap-3 px-4 py-4 rounded-xl bg-gradient-to-r from-[#00cdac]/10 to-[#62EC14]/10 hover:from-[#00cdac]/20 hover:to-[#62EC14]/20 transition text-main  mb-4 "
                    @click="shareWhatsApp(projectDetails)" target="_blank">
                    <WhatsApp class="size-8 text-[#00cdac]" />
                    <span class="text-base ">Share on Whatsapp</span>
                  </a>
              </div>
              <div class="mb-20">
                <div class="flex items-center justify-center gap-3">
                  <span class=" text-rose-500 text-xs  font-medium  flex items-center gap-2 flex-col justify-center rounded-xl bg-rose-50 shadow-sm ring-1 ring-rose-100 p-4 min-w-20 w-full"
                    @click="deleteProject(projectDetails.uuid)"><Delete class="size-5"/> Delete </span>
           
                  <router-link :to="{ name: 'EditProject', params: { uuid: projectDetails.uuid } }"
                    class="text-content text-xs font-medium text-opacity-50 flex items-center gap-2 flex-col justify-center rounded-xl bg-white/90 shadow-sm ring-1 ring-black/5 p-4 min-w-20 w-full"> <Edit class="size-5"/> Edit 
                  </router-link>
                  <a v-if="projectDetails.brochure_url" :href="projectDetails.brochure_url"
                    class="btn text-xs text-content font-medium text-opacity-50 flex items-center gap-2 flex-col justify-center rounded-xl bg-white/90 shadow-sm ring-1 ring-black/5 p-4 min-w-20 w-full" target="_blank"><Pdf class="size-5" />Brochure </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { numDifferentiation } from '@/assets/scripts/utility.js';
import ImageViewer from '@/components/Common/ImageViewer.vue';
import WhatsApp from '@/components/icons/WhatsApp.vue';
import Delete from '@/components/icons/Delete.vue';
import Edit from '@/components/icons/Edit.vue';
import Pdf from '@/components/icons/Pdf.vue';
export default {
  components: {
    ImageViewer,
    WhatsApp,
    Delete,
    Edit,
    Pdf
  },
  data() {
    return {
      photoUrl: [],
      imgList: [],
      projectDetails: {},
      visible: false,
      index: 0,
    }
  },
  created() {
    this.loadProjectDetails()
  },

  methods: {
    shareWhatsApp(proj_detail) {
      window.open(`https://api.whatsapp.com/send?text=%F0%9F%8F%A8+Project+Details%0D%0A%F0%9F%91%89+Project+Name+%3A+${proj_detail.name}${proj_detail.possession_status ? '%0D%0A%F0%9F%91%89+Possession+On+%3A+' + proj_detail.possession_status : ''}${proj_detail.formatted_possession_date ? '%0D%0A%F0%9F%91%89+Possession+Date+%3A+' + proj_detail.formatted_possession_date : ''}${proj_detail.property_age ? '%0D%0A%F0%9F%91%89+Property+Age+%3A+' + proj_detail.property_age + '+Years' : ''}${proj_detail.rera_no ? '+%0D%0A%F0%9F%91%89+Rera+No%3A+' + proj_detail.rera_no : ''}${proj_detail.project_approve_by ? '%0D%0A%F0%9F%91%89+Project+Approved+by%3A+' + proj_detail.project_approve_by : ''}${proj_detail.location ? '%0D%0A%F0%9F%91%89+Project+Location%3A+' + proj_detail.location : ''}${proj_detail.city ? '%0D%0A%F0%9F%91%89+City+%3A+' + proj_detail.city : ''}${proj_detail.locality ? '%28East%29%2C+' + proj_detail.locality : ''}%0D%0A%0D%0A%F0%9F%8C%8D+++https%3A%2F%2Fwww.google.com%2Fmaps%2Fsearch%2F%3Fapi%3D1%26query%3D${proj_detail.lat}%2C${proj_detail.long}%0D%0A%0D%0A`)
    },
    deleteProject(uuid) {
      let vm = this;
      this.$swal.fire({
        title: "Delete this Project?",
        buttons: true,
        buttons: ["No", "Yes"]
      }).then(confirm => {
        if (confirm) {
          vm.$axios
            .delete(`mobile_crm/projects/${uuid}/delete`)
            .then(res => {
              this.$router.replace({ name: "Projects" });
              this.$swal.fire({
                title: "Deleted!",
                icon: "success"
              });
            })
            .catch(err => {
              this.$swal.fire({
                title: "Error",
                text: err.response.data.message,
                icon: "error"
              });
            });
        }
      });
    },
    priceinLacs(value) {
      return numDifferentiation(value)
    },
    showImg(img_url) {
      this.imgList = img_url
      this.index = 1
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },
    loadProjectDetails() {
      this.$axios.get(`mobile_crm/projects/${this.$route.params.uuid}`)
        .then((res) => {
          this.projectDetails = res.data.project
          this.photoUrl = this.projectDetails.image_url
        })
        .catch((err) => console.log(err));
    },
  },
  computed: {
    userName() {
      return localStorage.getItem('property-user-name')
    },
    created_user(){
      return this.$store.getters.created_user;
    },
    userEmail() {
      return localStorage.getItem('property-user-email')
    },
    userMobile() {
      return localStorage.getItem('property-user-mobile')
    }
  }
}

</script>
<style scoped>
.amenities-label {
  @apply border-r border-divider pr-3 mr-3 inline-flex mb-2;
}

.amenities-label:first-child {
  @apply pl-0;
}

.amenities-label:last-child {
  @apply border-none;
}

.img-gallery:nth-child(4) {
  @apply relative cursor-pointer pointer-events-auto;
}

.img-gallery:nth-child(4)::after {
  @apply absolute bg-black bg-opacity-50 inset-0 rounded-sm;
  content: '';
}

.img-gallery:nth-child(4) span {
  @apply flex;
}

@media (max-width:350px) {
  .h-fix {
    height: 50px;
  }
}
</style>